<template>
    <div> 
		<tab name="10"></tab>
        <div class="page-filter-box MT10">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">
                    <el-date-picker
                        v-model="datetimerange"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="日期"
                        end-placeholder="日期"
                        size="small"
                        value-format="yyyy-MM-dd"
                        :clearable="false"
                        style="width:100%"
                        unlink-panels
                        >
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
		<template v-if="dataStatistics">
		    <div class="page-group-title"><span>汇总统计</span></div>
		    <el-card v-loading="fetchStatisticsLoading" shadow="never" class="statistics-box">
		        <el-row :gutter="20">
		            <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{dataStatistics.helpServiceFee || '0.00'}}</p><p class="color-info">定时服务费</p></el-col>
		            <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{dataStatistics.alternateServiceFee || '0.00'}}</p><p class="color-info">候补服务费</p></el-col>
		            <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{dataStatistics.consignServiceFee || '0.00'}}</p><p class="color-info">托售服务费</p></el-col>
		        </el-row>
		    </el-card>
		</template>
		<div class="page-group-title"><span>列表</span></div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				<el-table-column prop="time" label="日期"></el-table-column>
                <el-table-column prop="helpServiceFee" label="定时购票服务费" min-width="150"></el-table-column>
                <el-table-column prop="alternateServiceFee" label="候补服务费"></el-table-column>
				<el-table-column prop="consignServiceFee" label="托售服务费"></el-table-column>                
            </el-table>
        </div>

        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from './../../components/tab';
import dayjs from 'dayjs';
const defaultParams = {
    pageNo:1,
    timeStart:'',
    timeEnd:'',
    // timeStart: "00:00:00",
    // timeEnd: "23:59:59"
}
export default {
	components:{Tab},
    data(){
        const endTime = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd' );
       		const date = new Date();				const month = date.getMonth();		const day = date.getDate();				const start = new Date();		const end = new Date();				start.setMonth(month - 3, day + 1);		start.setHours(0, 0, 0);				end.setHours(23, 59, 59);		        const startTime =  dayjs(start).format('YYYY-MM-DD')
        return{
            dataStatistics: null,
			data:null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            },
            listLoading: false,
			fetchStatisticsLoading:false,
            datetimerange: [this.$route.query.timeStart || startTime, this.$route.query.timeStartss || endTime],
        }
    },
    mounted(){
        this.getStatistics();
		this.getDataList()
    },
    methods:{
        //获取dataStatistics
        getStatistics() {
            if( !this.datetimerange || this.datetimerange.length < 1 ){
                this.$message.error('请选择查询时间段')
                return;
            }
            const _timeRang = new Date( this.datetimerange[1] ) - new Date( this.datetimerange[0] );
            const _yearRang = parseInt(_timeRang / 24 / 3600 / 1000);
            if( _yearRang > 730 ){
                this.$message.error('目前仅支持最多2年的数据');
                return;
            }
            this.fetchStatisticsLoading = true;
            this.params = {
                ...this.params,
                timeStart:this.datetimerange ? this.datetimerange[0] + ' 00:00:00' : null,
                timeEnd:this.datetimerange ? this.datetimerange[1] + ' 23:59:59' : null
            }
            this.$request({
                url: "/sales/service/statistics",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.dataStatistics = result;
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.fetchStatisticsLoading = false;
                });
        },
		//获取getDataList
		getDataList() {
		    if( !this.datetimerange || this.datetimerange.length < 1 ){
		        this.$message.error('请选择查询时间段')
		        return;
		    }
		    const _timeRang = new Date( this.datetimerange[1] ) - new Date( this.datetimerange[0] );
		    const _yearRang = parseInt(_timeRang / 24 / 3600 / 1000);
		    if( _yearRang > 730 ){
		        this.$message.error('目前仅支持最多2年的数据');
		        return;
		    }
		    this.listLoading = true;
		    this.params = {
		        ...this.params,
		        timeStart:this.datetimerange ? this.datetimerange[0] + ' 00:00:00' : null,
		        timeEnd:this.datetimerange ? this.datetimerange[1] + ' 23:59:59' : null
		    }
		    this.$request({
		        url: "/sales/service/list",
		        method: "POST",
		        data: this.params,
		    })
		        .then((res) => {
		            const { state, msg, result } = res.data;
		            if (state == 1 && result) {
		                this.data = result;
		                this.dataList = result.result || [];
		            } else {
		                this.$message.error(msg || "请求失败");
		            }
		        })
		        .catch(() => {
		            this.$message.error("请求错误");
		        })
		        .finally(() => {
		            this.listLoading = false;
		        });
		},
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
			
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
			this.getStatistics()
        },
        //重置搜索
        reset() {
			const endTime = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd' );
			       
			const date = new Date();		
			const month = date.getMonth();
			const day = date.getDate();		
			const start = new Date();
			const end = new Date();		
			start.setMonth(month - 3, day + 1);
			start.setHours(0, 0, 0);		
			end.setHours(23, 59, 59);		
			const startTime =  dayjs(start).format('YYYY-MM-DD')
			this.datetimerange =[this.$route.query.timeStart || startTime, this.$route.query.timeStart || endTime],
			
            
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
			this.getStatistics()
        },
    }
}
</script>

<style lang="scss" scoped>
.el-table{
    a{
        display: block;
        color: $--color-theme;
        &:hover{
            text-decoration: underline;
        }
    }
}
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>
